//START GENAI@CHATGPT4
//START GENAI@GHCOPILOT
const defaultMapping = {
  CARD_APPLICATION_CRYPTOGRAM_LONG_FORM: 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
  CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM: 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM',
  CARD_SECURITY_CODE: 'CARD_SECURITY_CODE',
  CARDHOLDER_AUTHENTICATION_CRYPTOGRAM: 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
  DYNAMIC_CARD_SECURITY_CODE: 'CARD_SECURITY_CODE',
  NONE: 'NONE'
};

//START GENAI@GHCOPILOT
export const dynamicDataTypeMapping: { [key: string]: { [key: string]: string } } = {
  AMEX: { ...defaultMapping },
  DISCOVER: { ...defaultMapping },
  MASTERCARD: { ...defaultMapping },
  VISA: {
    CARD_APPLICATION_CRYPTOGRAM_LONG_FORM: 'CARD_APPLICATION_CRYPTOGRAM_LONG_FORM',
    CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM: 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM',
    CARD_SECURITY_CODE: 'DYNAMIC_CARD_SECURITY_CODE',
    CARDHOLDER_AUTHENTICATION_CRYPTOGRAM: 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
    DYNAMIC_CARD_SECURITY_CODE: 'DYNAMIC_CARD_SECURITY_CODE',
    NONE: 'NONE'
  }
};
//END GENAI@GHCOPILOT
//END GENAI@GHCOPILOT
//END GENAI@CHATGPT4
